import React from 'react';

import { useTileContext } from 'widgets/tiles/components/tile/TileContext';
import { useSelectLocked } from 'layoutRenderer/store/selectors';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { useDispatchRemoveTile } from 'widgets/tiles/store/config/dispatcher';

export function RemoveTileToolbarButton() {
    const tileContext = useTileContext();
    const isLocked = useSelectLocked();
    const dispatchRemoveTile = useDispatchRemoveTile(tileContext.widgetKey);

    if (isLocked) {
        return <></>;
    }

    return <Icon name="close" onClick={dispatchRemoveTile} />;
}
